module.exports = __webpack_public_path__ + "static/media/header-bg-secondary.116315a7.png";